import { __assign, __rest } from "tslib";
import { StyledImage, StyledPicture } from './image.styled';
import { sizesBuilder, srcSetBuilder } from './utils/srcSetBuilder';
import { ImageBuilder } from '@at/schema-utils/lib/builders/image';
import React, { forwardRef } from 'react';
import { Schema } from '../schema/schema';
import { addLoadingClass } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
var buildImageSchema = function (imageSchema) {
    return ImageBuilder.aBuilder(imageSchema.url, imageSchema.width, imageSchema.height)
        .withName(imageSchema.name)
        .withDescription(imageSchema.description)
        .withContentUrl(imageSchema.contentUrl)
        .build();
};
export var Image = forwardRef(function (_a, ref) {
    var additionalClass = _a.additionalClass, attributes = _a.attributes, onInteraction = _a.onInteraction, src = _a.src, srcSet = _a.srcSet, _b = _a.alt, alt = _b === void 0 ? '' : _b, loading = _a.loading, shouldLazyLoad = _a.shouldLazyLoad, _c = _a.className, className = _c === void 0 ? '' : _c, imageAttributes = _a.imageAttributes, imageSchema = _a.imageSchema, onClick = _a.onClick, ratioType = _a.ratioType, otherHTMLProperties = __rest(_a, ["additionalClass", "attributes", "onInteraction", "src", "srcSet", "alt", "loading", "shouldLazyLoad", "className", "imageAttributes", "imageSchema", "onClick", "ratioType"]);
    var pictureClassList = conditionalClassList("atds-image__container", !!className && className, !!additionalClass && additionalClass);
    var handleOnClick = function (event) {
        if (onInteraction)
            onInteraction(event);
        if (onClick)
            onClick(event);
    };
    return (React.createElement(React.Fragment, null,
        imageSchema && React.createElement(Schema, { schema: buildImageSchema(imageSchema) }),
        React.createElement(StyledPicture, __assign({ className: pictureClassList, onClick: handleOnClick, ratioType: ratioType }, attributes, otherHTMLProperties),
            srcSet &&
                srcSet.map(function (item, key) {
                    var type = item.type, media = item.media, size = item.size, itemAttributes = item.attributes;
                    var imageSrcSet = srcSetBuilder(item);
                    var mediaQuery = media ? "(min-width: ".concat(media, ")") : undefined;
                    var sizes = size ? sizesBuilder(size) : undefined;
                    return (React.createElement("source", __assign({ key: key, srcSet: imageSrcSet, media: mediaQuery, sizes: sizes, type: type }, itemAttributes)));
                }),
            React.createElement(StyledImage, __assign({ className: "atds-image ".concat(addLoadingClass(loading)), src: src, alt: alt, isLoading: loading, loading: shouldLazyLoad ? 'lazy' : undefined, ref: ref }, imageAttributes)))));
});
Image.displayName = 'Image';
